import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import account from './modules/account'
import user from './modules/user'
import role from './modules/role'
import tenant from './modules/tenant'
import campaign from "@/store/modules/campaign";
import giftPackage from "@/store/modules/gift-package";
import main from "@/store/modules/main";
import giftInfo from './modules/gift-info'
import lotteryRecords from './modules/lottery-records'
import apiLogs from './modules/api-logs'
const store = new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {},
    modules: {
        app,
        session,
        account,
        user,
        role,
        tenant,
        campaign,
        giftPackage,
        main,
        giftInfo,
        lotteryRecords,
        apiLogs
    }
});

export default store;